// removed by extract-text-webpack-plugin
module.exports = {"BreadBottom":"BurgerIngredient__BreadBottom__3qkcO","BreadTop":"BurgerIngredient__BreadTop__1fUH2","Seeds1":"BurgerIngredient__Seeds1__3Okq_","Seeds2":"BurgerIngredient__Seeds2__1-xFH","Meat":"BurgerIngredient__Meat__22GA_","Cheese":"BurgerIngredient__Cheese__2o8lq","Salad":"BurgerIngredient__Salad__2c2tR","Bacon":"BurgerIngredient__Bacon__1aTtY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Burger/BugerIngredient/BurgerIngredient.css
// module id = 108
// module chunks = 0